/* tslint:disable:max-line-length */
import { SegmentSpecificMessages } from "../../types/types";

export const firstResponderMessages: SegmentSpecificMessages = {
  emailExplanation: "Use your work email if you have one",
  step: {
    personalInfo: {
      title: "Unlock this 1st Responder-Only Offer",
      subtitle: "Verify you're an active first responder.",
      howDoesVerifyingWorkDetails:
        "This offer is available to all US first responders and emergency personnel - including law enforcement, EMTs, paramedics, and firefighters." +
        "<br></br>" +
        "{companyName} uses SheerID, a trusted partner, to verify that you are an active first responder. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: "Check Your Name, Email & Organization",
        subtitle:
          "Your full name, organization name, and email must match what is on record with your agency.",
      },
      verifyingTitle: "Verifying your first responder status",
      submitButtonText: "Verify My First Responder Status",
    },
    docUpload: {
      uploadInstructions: "Upload an official document that shows",
      title: "To continue, upload documents that confirm your first responder status",
      whoIsSheerId:
        "Document review is handled by SheerID, a trusted partner who specializes in verifying first responders.",
    },
    success: {
      title: "You've been verified",
      subtitle: "You are now eligible for this special offer.",
      redirectButtonText: "Continue",
    },
  },
};
